var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.84629 2.73077C6.84629 3.68665 6.07141 4.46154 5.11553 4.46154C4.15965 4.46154 3.38477 3.68665 3.38477 2.73077C3.38477 1.77489 4.15965 1 5.11553 1C6.07141 1 6.84629 1.77489 6.84629 2.73077Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.84629 8.50002C6.84629 9.45589 6.07141 10.2308 5.11553 10.2308C4.15965 10.2308 3.38477 9.45589 3.38477 8.50002C3.38477 7.54409 4.15965 6.76923 5.11553 6.76923C6.07141 6.76923 6.84629 7.54409 6.84629 8.50002Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.84629 14.2692C6.84629 15.2251 6.07141 15.9999 5.11553 15.9999C4.15965 15.9999 3.38477 15.2251 3.38477 14.2692C3.38477 13.3133 4.15965 12.5384 5.11553 12.5384C6.07141 12.5384 6.84629 13.3133 6.84629 14.2692Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.6158 2.73077C12.6158 3.68665 11.841 4.46154 10.885 4.46154C9.92916 4.46154 9.1543 3.68665 9.1543 2.73077C9.1543 1.77489 9.92916 1 10.885 1C11.841 1 12.6158 1.77489 12.6158 2.73077Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.6158 8.50002C12.6158 9.45589 11.841 10.2308 10.885 10.2308C9.92916 10.2308 9.1543 9.45589 9.1543 8.50002C9.1543 7.54409 9.92916 6.76923 10.885 6.76923C11.841 6.76923 12.6158 7.54409 12.6158 8.50002Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.6158 14.2692C12.6158 15.2251 11.841 15.9999 10.885 15.9999C9.92916 15.9999 9.1543 15.2251 9.1543 14.2692C9.1543 13.3133 9.92916 12.5384 10.885 12.5384C11.841 12.5384 12.6158 13.3133 12.6158 14.2692Z",
    fill: "#AFAFAF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots_icon.c23a9039cbe84ade5b92e5a2bd0ddc9f.svg";
export { ForwardRef as ReactComponent };